module.exports = __webpack_public_path__ + "img/pdf.478aa7d5.jpg";